import { IconName } from '@/components/elements/icon/icons';

interface Props {
    name: IconName;
    color?: string;
    ariaLabel?: string;
    iconClass?: string;
}

export default function Icon2({ iconClass = '', ...props }: Props) {
    return (
        <svg aria-label={props.ariaLabel} className={iconClass} style={{ color: props.color }}>
            <use href={`/assets/icons.svg#${props.name}`} />
        </svg>
    );
}
